import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  useSnackbarContext,
  Divider,
} from "@inductiveautomation/ws-components";
import { Container } from "@mui/material";
import { handleResponse } from "../../../utilities/api_response";
import { usePostMakerLicenseMutation } from "../api/makerLicenses.api";
import { getLicenseStyles } from "../License/_licenseStyle.ts";

const GetLicenseDialog = ({
  open,
  onClose,
  onSubmit,
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}) => {
  const [createMakerLicense] = usePostMakerLicenseMutation();
  const { t } = useTranslation();
  const { addSnackbar } = useSnackbarContext();
  const [accepted, setAccepted] = useState(false);
  const testId = "maker-licenses-get-license";
  const { cx, classes } = getLicenseStyles();

  const reset = () => setAccepted(false);
  const internalOnClose = () => {
    reset();
    onClose();
  };

  return (
    <Dialog
      testId={testId}
      isOpen={open}
      onClose={internalOnClose}
      showCloseButton
      contentClassName={classes.licenseDialogMainContent}
      headline={t("maker_licenses.actions.get_license.heading")}
      supportingText={t("maker_licenses.actions.get_license.supporting_text")}
      contentArea={
        <Container className={cx(classes.eulaContainer)} sx={{ padding: "0" }}>
          <Divider />
          <iframe
            src="https://inductiveautomation.com/ignition/license"
            title={t("maker_licenses.actions.get_license.heading")}
            className={classes.eulaFrame}
          />
          <Divider />
        </Container>
      }
      fullWidthContentArea={true}
      helper={{
        helperConfirmLabel: t("maker_licenses.actions.get_license.helper_text"),
        checked: accepted,
        onCheckboxChange: setAccepted,
      }}
      actions={[
        {
          testId: `${testId}-cancel`,
          type: "cancel",
          label: t("common.cancel"),
          onClick: internalOnClose,
        },
        {
          testId: `${testId}-submit`,
          type: "submit",
          label: t("maker_licenses.actions.get_license.submit"),
          disabled: !accepted,
          onClick: () => {
            createMakerLicense()
              .then((response) => {
                handleResponse(response, {
                  onSuccess: () => {
                    addSnackbar(
                      t("maker_licenses.actions.get_license.success_message")
                    );
                    reset();
                    onSubmit();
                  },
                  onError: () => {
                    addSnackbar(
                      t("maker_licenses.actions.get_license.error_message"),
                      { type: "error" }
                    );
                    internalOnClose();
                  },
                  fallbackErrorMessage: t(
                    "maker_licenses.actions.get_license.error_message"
                  ),
                });
              })
              .catch((error: unknown) => {
                console.error(error);
                addSnackbar(
                  t("maker_licenses.actions.get_license.error_message"),
                  { type: "error" }
                );
                internalOnClose();
              });
          },
        },
      ]}
    />
  );
};

export default GetLicenseDialog;
